var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-setting-modal"},[_c('page-header',{attrs:{"header_back":true,"header-title":_vm.$t('profile_setting')}}),_c('member-write-component',{attrs:{"member-type":'profileSetting',"memberKey":_vm.UserInfo.mb_no}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }